module.exports = __webpack_public_path__ + "a5c5fd8500edf2260d8b0ba71d91d816.png";